// 动态设置根字体大小
function setRem() {
    const html = document.documentElement;
    const clientWidth = html.clientWidth; // 获取窗口宽度
  
    // 设计稿宽度为 1920px，1rem = 100px
    if (clientWidth >= 1920) {
      html.style.fontSize = '100px';
    } else {
      html.style.fontSize = `${clientWidth / 19.2}px`; // 1920 / 19.2 = 100px
    }
  }
  
  // 初始调用
  setRem();
  
  // 监听窗口大小变化
  window.addEventListener('resize', setRem);